







































































import { Component, Prop, Vue, Watch, Mixins } from 'vue-property-decorator'
import { TOKEN, SO_FAR } from '@/store/mutation-types'
import PageLayout from '@/components/page/PageLayout.vue'
import ImageInfo from './ImageInfo.vue'
import SuperTabs from '@/views/AiiTasks/SuperTabs.vue'
import riskSection from '@/views/AiiTasks/riskSection.vue'
import DetailHeaderBtns from '@/components/task/DetailHeaderBtns.vue'
import TaskDetailMixins from '@/mixins/taskDetail'

@Component({
	name: 'AiiTaskDetail',
	components: {
		PageLayout,
		ImageInfo,
		SuperTabs,
		riskSection,
		DetailHeaderBtns,
	},
})
export default class QueryList extends Mixins(TaskDetailMixins) {
	private canCreateConciliationOrder: boolean = false

	private getEx(data: any) {
		this.canCreateConciliationOrder = data.canCreateConciliationOrder
	}

	private toAddMediate() {
		// this.$ss.set('mediateOrderId', this.$route.params.orderId)
		this.$router.push({
			name: `addOfflineMediate`,
			params: { orderId: this.$route.params.orderId },
		})
	}
}
